import {
  createRouteStationDisplayList,
  RouteData,
} from 'logics/createRouteStationInitialList';
import { ChangeEvent, useState } from 'react';

/**
 * 路線駅のカスタムフック
 * @param initialRouteStationList
 * @returns 路線・駅の値と更新する関数を含むオブジェクト
 */
export const useRouteStation = (initialRouteStationList: RouteData[]) => {
  const [routeStationDisplayList, setRouteStationDisplayList] = useState<
    RouteData[]
  >(initialRouteStationList);
  const routeList = routeStationDisplayList;
  const stationList = routeStationDisplayList.flatMap(
    (station) => station.stationList
  );

  // 選択中の路線のid配列
  const selectedRouteIdList = routeList
    .filter(({ isChecked }) => isChecked)
    .map(({ id }) => id);

  const selectedStationIdList = stationList
    .filter(({ isChecked }) => isChecked)
    .map(({ id }) => id);

  // 路線のチェックボックス更新処理
  const updateIsCheckedRouteList = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = routeList.map((route) => {
      if (route.id !== selectedId) return route;
      return {
        ...route,
        isChecked: event.target.checked,
      };
    });

    const checkedRouteStationDisplayList = createRouteStationDisplayList(
      checkedList,
      stationList
    );
    setRouteStationDisplayList(checkedRouteStationDisplayList);

    return checkedList.filter(({ isChecked }) => isChecked).map(({ id }) => id);
  };

  // 駅のチェックボックス更新処理
  const updateIsCheckedStationList = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = stationList.map((station) => {
      if (station.id !== selectedId) return station;
      return {
        ...station,
        isChecked: event.target.checked,
      };
    });

    const checkedRouteStationDisplayList = createRouteStationDisplayList(
      routeList,
      checkedList
    );
    setRouteStationDisplayList(checkedRouteStationDisplayList);

    return checkedList.filter(({ isChecked }) => isChecked).map(({ id }) => id);
  };

  // チェック状態クリア処理
  const clearIsCheckRouteStationList = () => {
    setRouteStationDisplayList([]);
  };

  return {
    setRouteStationDisplayList,
    routeStationDisplayList,
    selectedRouteIdList,
    selectedStationIdList,
    clearIsCheckRouteStationList,
    updateRouteStationFunctions: {
      updateIsCheckedRouteList,
      updateIsCheckedStationList,
    },
  };
};
